<section class="container">
  <h1 class="text-[#00EED0] font-semibold  mb-3 ps-5">Curriculums</h1>
  <p-tabs [value]="selectedTabId()">
    <p-tablist>
      @if (isLoadingTabs()) {
        <p-skeleton class="my-3" height="3rem" />
      } @else {
        @if (curriculumsTab()?.data.length) {
          @for (tab of curriculumsTab()?.data; track tab.id) {
            <p-tab class="capitalize" [value]="tab.id">{{ tab.title }}</p-tab>
          }
        } @else {
          <div class="flex justify-center items-center border border-red-400 bg-red-100 m-5 rounded-lg p-5">
            <h1 class="text-lg text-center capitalize text-red-400 font-bold">No curriclum available</h1>
          </div>
        }
      }
    </p-tablist>
    <p-tabpanels>
      @if (curriculumsTab()?.data.length) {
        @for (cur of curriculumsTab()?.data; track cur.id) {
          <p-tabpanel [value]="cur.id">
            <h1 class="text-[#00EED0] font-semibold my-3 ps-5">Boards</h1>

            <p-tabs [value]="selectedBoardId()">
              <p-tablist>
                @if (isLoadingTabs()) {
                  <p-skeleton class="my-3" height="3rem" />
                } @else {
                  @if (cur.boards.length) {
                    @for (tab of cur.boards; track tab.id) {
                      <p-tab class="capitalize" [value]="tab.id">{{ tab.title }}</p-tab>
                    }
                  } @else {
                    <div
                      class="flex justify-center w-full items-center border border-red-400 bg-red-100 m-5 rounded-lg p-5">
                      <h1 class="text-lg text-center capitalize text-red-400 font-bold">No boards available</h1>
                    </div>
                  }
                }
              </p-tablist>

              <p-tabpanels>
                @for (board of cur.boards; track board.id) {
                  <p-tabpanel [value]="board.id">
                    @if (isLoadingTabs()) {
                      <p-skeleton height="10rem" />
                    } @else {
                      @if (board.subjects?.length) {
                        <h1 class="text-primary text-xl font-bold my-3 ps-5">Subjects</h1>

                        <div class="grid px-4 gap-4 md:grid-cols-2 lg:grid-cols-3">
                          @for (subject of board.subjects; track subject.id) {
                            <div
                              #card
                              (mouseenter)="expandCard(card)"
                              (mouseleave)="collapseCard(card)"
                              class="card bg-primary-50 p-4 overflow-hidden hover:shadow transition-all duration-500 ease-in-out h-full md:h-[10.5rem] lg:h-[12rem] rounded-xl text-center text-primary cursor-pointer"
                              (click)="goToSubject(cur.slug, subject.slug, board?.slug, board.title)">
                              <div class="flex h-[60px] justify-center items-center mb-3">
                                <img width="50" height="60" [src]="subject.icon ?? 'Icons/star.png'" alt="icon" />
                              </div>
                              <h4 class="font-bold text-lg capitalize">{{ subject.title }}</h4>
                              <p class="text-sm line-clamp-none md:line-clamp-2 group-hover:line-clamp-none">
                                {{ subject.description }}
                              </p>
                            </div>
                          }
                        </div>
                      } @else {
                        <div
                          class="flex justify-center items-center border mx-4 border-red-400 bg-red-100 my-10 rounded-lg p-5">
                          <h1 class="text-2xl text-center capitalize text-red-400 font-bold">No subjects available</h1>
                        </div>
                      }
                    }
                  </p-tabpanel>
                }
              </p-tabpanels>
            </p-tabs>
          </p-tabpanel>
        }
      }
    </p-tabpanels>
  </p-tabs>
</section>

<div class="flex justify-end items-center my-10 px-10">
  <app-main-btn
    [routerLink]="['/']"
    [btnTxColor]="'white'"
    [borderColor]="'primary'"
    [btnColor]="'primary'"
    [btnName]="'Back'" />
</div>
